import { render, staticRenderFns } from "./MemoryGame1.vue?vue&type=template&id=ff69814e&scoped=true&"
import script from "./MemoryGame1.vue?vue&type=script&lang=js&"
export * from "./MemoryGame1.vue?vue&type=script&lang=js&"
import style0 from "./MemoryGame1.vue?vue&type=style&index=0&id=ff69814e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff69814e",
  null
  
)

export default component.exports